var map = {
	"./": "9d76",
	"./game": "50d1",
	"./game.vue": "50d1",
	"./index": "9d76",
	"./index.vue": "9d76",
	"./kuang": "3ef8",
	"./kuang.vue": "3ef8",
	"./market": "336c",
	"./market.vue": "336c",
	"./mine": "0af5",
	"./mine.vue": "0af5",
	"./team": "e61e",
	"./team.vue": "e61e"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "21dd";
module.exports = webpackAsyncContext;